// Resolves the report's own budget version and its comparison version to display
// names, from the configuration form's budget list.
//
// An archived report opened from the Generated Reports list has the figures but
// not the form that produced them, so it passes its stored parameters instead —
// with the names already resolved server-side, which also covers a version that
// has since been deleted. The generic fallbacks remain for anything that supplies
// neither.

/**
 * @param {Object} context      The Actuals vs Budget report context (may be empty).
 * @param {Object} storedReport A generated report's own parameters, when rendered
 *                              outside the configuration form. Takes precedence.
 * @returns {{versionName: string, comparisonName: string}}
 */
export const resolveVersionNames = (context = {}, storedReport = null) => {
    if (storedReport) {
        return {
            versionName: storedReport.budget_name || '',
            comparisonName: storedReport.comparison_budget_name || $t('Comparison'),
        };
    }

    const budgets = context.configs?.budgets || [];
    const criteria = context.criteria || {};

    const nameFor = (budgetId) => budgets.find(({ id }) => String(id) === String(budgetId))?.name;

    return {
        // Empty rather than guessed: the legend drops the "LE = …" sentence
        // instead of naming a version the report may not have used.
        versionName: nameFor(criteria.budget_id) || '',
        comparisonName: nameFor(criteria.comparison_budget_id) || $t('Comparison'),
    };
};
